import React from 'react';
import { useTranslation } from 'react-i18next';

const WhyLatviaSection = () => {
  const { t } = useTranslation('latvia');

  return (
    <article className="py-8 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-12 items-center">
          <div>
            <h2 className="text-lg md:text-4xl font-bold text-gray-900 mb-2.5 md:mb-6 font-serif">
              {t('detail.why.title')} <strong>{t('detail.why.titleBold')}</strong>?
            </h2>
            <p className="text-xs md:text-base text-gray-600 mb-2.5 md:mb-6 leading-relaxed">
              {t('detail.why.p1')}
            </p>
            <p className="text-xs md:text-base text-gray-600 mb-3 md:mb-6 leading-relaxed">
              {t('detail.why.p2')}
            </p>
            <div className="grid grid-cols-2 gap-2.5 md:gap-4">
              <div className="bg-gold-50 rounded-lg p-2.5 md:p-4 border border-gold-200">
                <div className="text-xl md:text-3xl font-bold text-gold-600 mb-0.5">26</div>
                <div className="text-[10px] md:text-sm text-gray-700">{t('detail.why.stat1')}</div>
              </div>
              <div className="bg-gold-50 rounded-lg p-2.5 md:p-4 border border-gold-200">
                <div className="text-xl md:text-3xl font-bold text-gold-600 mb-0.5">1.9M</div>
                <div className="text-[10px] md:text-sm text-gray-700">{t('detail.why.stat2')}</div>
              </div>
            </div>
          </div>

          <div className="relative order-first lg:order-last">
            <img
              src="https://public.readdy.ai/ai/img_res/c5342aae557fa0f5a8873bb210a76d62.jpg"
              alt="Định cư Latvia - Trung tâm thành phố Riga hiện đại"
              className="rounded-xl md:rounded-2xl shadow-xl md:shadow-2xl w-full h-48 md:h-auto object-cover object-top"
            />
          </div>
        </div>
      </div>
    </article>
  );
};

export default WhyLatviaSection;